import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class RolesService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getRoles(): Observable<any> {
    return this.http.get(`${this.baseUrl()}`);
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/roles`;
  }
}
